<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <div class="col text">
          <h1>Cookiebeleid</h1>
          <p>
            Welkom bij Koninklijke Rijnja! Dit Cookiebeleid is bedoeld om u
            inzicht te geven in hoe wij cookies en vergelijkbare technologieën
            gebruiken op onze website. We begrijpen dat privacy belangrijk is,
            en daarom willen we u duidelijk informeren over wat er gebeurt met
            uw gegevens wanneer u onze website bezoekt.
          </p>
          <p>
            Wilt u de huidige cookie instellingen aanpassen? Klik dan hier:
          </p>
          <button class="link-button" @click="showCookieDialog()">
            Cookie instellingen aanpassen
          </button>
          <h2>Wat zijn cookies en vergelijkbare technologieën?</h2>
          <p>
            Cookies zijn kleine tekstbestanden die op uw computer of mobiele
            apparaat worden opgeslagen wanneer u onze website bezoekt. Deze
            bestanden bevatten informatie die ons helpt u te herkennen en de
            website optimaal te laten functioneren.
          </p>
          <h2>Waarom gebruiken we cookies?</h2>
          <p>
            We maken gebruik van cookies om uw bezoek aan onze website te
            verbeteren en te vereenvoudigen. Dit omvat het bewaren van
            informatie zoals items in uw winkelwagen en het vergemakkelijken van
            het bestelproces. Ook helpen cookies ons om statistieken over het
            gebruik van onze website te verzamelen, waardoor we de website beter
            kunnen afstemmen op het gebruik.
          </p>
        </div>
        <div class="col image">
          <img class="cookies" src="@/images/pages/cookies.svg" />
          <div class="bg-circle g-w"></div>
        </div>
      </section>

      <section id="" class="row reverse">
        <div class="col text">
          <h2>Soorten cookies die we gebruiken</h2>
          <p>
            We gebruiken twee hoofdtypen cookies:
          </p>
          <ul>
            <li>
              Functionele cookies: Deze zijn van essentieel belang voor het
              correct functioneren van onze website en omvatten functies zoals
              winkelwagentjes en bestelprocessen.
            </li>
            <li>
              Analytische cookies: Hiermee verzamelen we statistieken over hoe
              onze website wordt gebruikt, waardoor we continue verbeteringen
              kunnen doorvoeren.
            </li>
          </ul>
          <h2>Cookies van derden</h2>
          <p>
            Op sommige pagina's van onze website kunnen cookies van derden
            worden geplaatst. Het privacy- en cookiebeleid van deze derde
            partijen is van toepassing op het gebruik van hun cookies. Voor de
            cookies die deze partijen plaatsen, verwijzen wij u naar de
            verklaringen op de websites van deze partijen. Deze verklaringen
            kunnen regelmatig wijzigen, daarom raden wij u aan deze privacy- en
            cookieverklaringen regelmatig te raadplegen.
            <br />De volgende partijen plaatsen via onze website cookies en/of
            overige technieken:
          </p>
          <ul>
            <li>
              <a href="https://policies.google.com/privacy" class="link-text"
                >Google</a
              >
            </li>
            <!--  <li>
              <a
                href="https://www.linkedin.com/legal/privacy-policy"
                class="link-text"
                >Linkedin</a
              >
            </li> -->
          </ul>
        </div>
        <div class="image col">
          <img class="stats" src="@/images/pages/stats-screen.svg" />
        </div>
      </section>

      <section id="" class="row">
        <div class="col text">
          <h2>Cookie-instellingen beheren</h2>
          <p>
            U hebt de controle over uw cookie-instellingen. U kunt uw browser
            aanpassen om waarschuwingen te ontvangen voordat cookies worden
            geplaatst, cookies weigeren of reeds geplaatste cookies verwijderen.
          </p>
          <h2>
            Cookiehistorie verwijderen
          </h2>
          <p>
            U kunt eenvoudig uw cookiehistorie verwijderen via de instellingen
            van uw browser. Raadpleeg de handleiding van uw browser voor
            gedetailleerde instructies.
          </p>
          <h2>
            Wijzigingen in het Cookiebeleid
          </h2>
          <p>
            Dit Cookiebeleid kan worden aangepast als gevolg van wetswijzigingen
            of veranderingen in de werking van onze website. De meest recente
            versie van dit beleid is altijd te vinden via een link onderaan elke
            pagina van onze website.
          </p>

          <!-- <h2>Privacy beleid van Koninklijke Rijnja</h2>
          <p>
            Voor een dieper inzicht in hoe we omgaan met persoonsgegevens,
            verwijzen we je naar ons privacy beleid.
          </p>
          <h2>
            Wijzigingen in het Cookiebeleid
          </h2>
          <p>
            Dit Cookiebeleid kan worden aangepast als gevolg van wetswijzigingen
            of veranderingen in de werking van onze website. De meest recente
            versie van dit beleid is altijd te vinden via een link onderaan elke
            pagina van onze website.
          </p> -->
        </div>
        <div class="image col">
          <img class="printstore" src="@/images/pages/printstore.svg" />
        </div>
      </section>
      <section id="" class="row col-single">
        <div class="col text">
          <h1>Privacy beleid van Koninklijke Rijnja</h1>
          <p>
            Voor een dieper inzicht in hoe we omgaan met persoonsgegevens,
            verwijzen we je naar ons
            <router-link class="link-text" to="/privacyverklaring"
              >privacy beleid.</router-link
            >
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
import { EventBus, Events } from '@/eventbus/EventBus'

export default {
  components: { SiteFooter },
  methods: {
    showCookieDialog() {
      EventBus.emit(Events.SHOW_COOKIE_DIALOG)
    }
  }
}
</script>

<style lang="scss" scoped>
.pill-button {
  margin-top: 10px;
}
h1 {
}
h2 {
  margin-top: 20px;
}
.erkende-betrouwbaarheid {
  max-width: 425px;
}

.security {
  max-width: 425px;
}

.checklist {
  max-width: 390px;
}

.printstore {
  max-width: 365px;
}

.klant {
  max-width: 350px;
}

.slider,
.stats,
.form {
  max-width: 250px;
}

.cookies {
  max-width: 320px;
}

.col-single {
  max-width: 860px;
}
</style>
